<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<div *ngIf="phoneForm" class="page-container top-fix resize-index start-column-vertical-centered-container min-height-100vh">
  <div class="white-card position-rel">
    <div class="login-content start-column-vertical-centered-container column-gap-1p5625em">
      <div class="stretched-aligned-column-container column-gap-1p5625em">
        <div class="flex-column column-gap-0p625em text-align-center">
          <div class="login-title line-height-120 ">Your phone number</div>
          <div class="font-2em">Provided number will be used for 2-step verification.</div>
        </div>

        <div
          class="centered-row-container flex-grow row-gap-0p5em"
          [formGroup]="phoneForm"
          (ngSubmit)="onSubmit()">
          <app-input
            class="width-25pcnt"
            formControlName="code"
            prefixText="+"
            maxLength="4"
            [separator]="'separator.0'">
          </app-input>
          <app-input
            class="width-75pcnt flex-grow-1 text-align-left"
            formControlName="phone"
            maxLength="15"
            [separator]="'separator.0'"
            [placeholder]="'Enter your phone number'">
          </app-input>
        </div>
        <app-button
          data-qa="save-publish-period-button"
          #verifyButton
          [additionalClasses]="'width-100pcnt'"
          [size]="'medium'"
          [bordersSquaredShape]="'full'"
          [type]="'accent'"
          [showSpinner]="true"
          [disabled]="isVerifyDisabled"
          (buttonClick)="onSubmit()">{{ isVerifyDisabled ? '' : 'Verify' }}
        </app-button>
      </div>
    </div>
  </div>
</div>
